import i18next from 'i18next';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import './ReportQRPageTranslate';
import { useTranslation } from 'react-i18next';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import { reportQRColumns } from './ReportQRPageColumns';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { clearState, loadData, reportQRPageModule } from './ReportQRPageDucks';
import FilterDatePicker from '../../components/TableFilter/ColumnsFilters/FilterDatePicker';
import FilterTreeSelect from '../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ROLES } from '../../_helpers/Constants';
import useUser from '../LoginPage/useUser';

export default function ReportQRPage() {
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_reportQR') }
  ];
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useUser();
  const [isLocation, setIsLocation] = useState(false);
  const { nextPage, filter, reloadPage } = useTableFilter((filter) => dispatch(loadData({ filter })));
  const loading = useSelector(state => state[reportQRPageModule].loadingTable);
  const data = useSelector(state => state[reportQRPageModule].tableData);
  useEffect(() => {
    if (user) {
      user.roles.forEach((item) => {
        if (item === ROLES.ES_GODS) {
          setIsLocation(true);
        }
      });
    }
    return () => {
      dispatch(clearState())
    }
  }, []);

  useEffect(() => {
    if (!data.content.length) {
      reloadPage()
    }
  }, [user])
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('reportPage_title')}</h3>
        <div className="pb2 flex flex-wrap">
          <FilterDatePicker
            name="dateMin"
            placeholder={t('monitoring_fromDate')}
            style={{ marginRight: 10, width: 230 }}
          />
          <FilterDatePicker
            name="dateMax"
            placeholder={t('monitoring_toDate')}
            style={{ marginRight: 10, width: 230 }}
          />
          {
            isLocation &&
            <div style={{ width: 300 }}>
              <FilterTreeSelect
                lookupId="60"
                name="serviceProviderLocation"
                lang={i18n.language}
                filter={item => item.ARM_gu === 'true'}
              />
            </div>
          }
        </div>
        {
          !filter.serviceProviderLocation && isLocation &&
          <FormHelperText error style={{
            marginBottom: '10px',
            fontSize: '14px'
          }}>{t('reportPage_isShowDataTable')}</FormHelperText>
        }
        <StaticTablePagination
            columns={reportQRColumns({ t, lang: i18n.language })}
            loading={loading}
            data={data.content}
            totalElements={data.totalElements}
            sortable={false}
            onClickLoadMore={() => nextPage()}
          />
      </Paper>
    </>
);
}
